import React, { useMemo, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { Markers, VisTimelineVanillaJs, MainHeader } from 'Elements';
import styles from 'partials/mapbox.module.scss';

export const Mapbox = React.memo(() => {
	const initialState = {
		zoom: 3,
		zoomSnap: 0,
		zoomDelta: 0.85,
		center: {
			lat: 30.3753, // 35.69439,
			lng: 69.3451 //51.42151
		},
		tileUrl:
			'https://api.mapbox.com/styles/v1/seyedahmadreza/ckpe5e0q620do17o4djiu23q4/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2V5ZWRhaG1hZHJlemEiLCJhIjoiY2trZmp4cm51MGNlNjJwbndnNWg5ZnIyMyJ9.c35FsY9WSeHe0jWPXtlC1w',
		tileAttribution: ''
	};
	const [state] = useState(initialState);
	const isDesktop = useMediaQuery({ minWidth: 992 });

	const mapPlaceholder = useMemo(() => {
		return (
			<p>
				<noscript>
					You need to enable JavaScript to see this map.
				</noscript>
			</p>
		);
	}, []);

	const displayMap = useMemo(() => {
		return (
			<MapContainer
				fallback="is loading map"
				scrollWheelZoom
				wheelPxPerZoomLevel={90}
				className={styles.map}
				center={[state.center.lat, state.center.lng]}
				zoom={state.zoom}
				zoomDelta={state.zoomDelta}
				zoomSnap={state.zoomSnap}
				placeholder={mapPlaceholder}
				zoomControl={false}>
				<ZoomControl position="bottomleft" />
				<TileLayer
					fallback="is loading tile"
					noWrap
					maxZoom={19}
					minZoom={2}
					url={state.tileUrl}
					attribution={state.tileAttribution}
				/>
				<Markers />
			</MapContainer>
		);
	}, [state, mapPlaceholder]);

	return (
		<div className={styles.container}>
			<div className={styles.mapbox}>
				{isDesktop && <MainHeader className={styles.header} />}
				{displayMap}
			</div>
			<VisTimelineVanillaJs />
		</div>
	);
});
